/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/no-unescaped-entities */
import React, { useEffect, useState } from 'react';
import Passo1 from 'assets/images/dr_licita/passo-1.gif';
import Passo2 from 'assets/images/dr_licita/passo-2.gif';
import Table from 'assets/images/dr_licita/table.png';
import IconSession from 'assets/images/robo-sale/icon-session-2.svg';
import Money from 'assets/images/dr_licita/money.svg';
import Clock from 'assets/images/dr_licita/clock.svg';
import Justice from 'assets/images/dr_licita/justice.svg';
import Card from 'assets/images/dr_licita/card.png';
import IconComment from 'assets/images/robo-sale/icon-comment.svg';

import { ProportionalSaleTypes } from 'store/modules/proportional_sale_simulation_store/types';
import { useDispatch } from 'react-redux';
import { Container } from './styles';

interface SaleRoboProps {
  dados: any;
}

const PageSaleDrLicita = (props: SaleRoboProps) => {
  const { dados } = props;
  const dispatch = useDispatch();
  const [sale, setSale] = useState<boolean>(false);

  useEffect(() => {
    (async () => {
      if (sale && dados) {
        dispatch({
          type: ProportionalSaleTypes.DADOS_PROPORTIONAL_SALE,
          dados,
          servico: [16],
        });
      }
    })();
  }, [sale]);

  return (
    <Container>
      <div className="container position-one">
        <div className="row mb-4 px-md-4 py-0 py-md-4">
          <div className="col-md-6 mt-5">
            <h1 className="font-weight-bold">Conheça o Dr. Licita</h1>
            <h4 className="mt-3">
              A primeira inteligência artificial do mercado que <br /> identifica a melhor tese e
              elabora impugnações, <br /> recursos e contrarrazões para sua licitação, em <br />
              <strong>menos de um minuto.</strong>
            </h4>
            <button
              type="button"
              className="btn btn-success button-green"
              onClick={() => {
                const element = document.getElementById('conhecer');
                if (element) {
                  element.scrollIntoView({ behavior: 'smooth' });
                }
              }}
            >
              CONHECER O DR. LICITA
            </button>
          </div>
          <div className="col-md-6">
            <iframe
              title="Robô de Lances ConLicitação"
              id="video"
              width="100%"
              height="295"
              src="https://player.vimeo.com/video/1091861778"
              frameBorder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="container-video"
            />
          </div>
        </div>
      </div>
      <div className="bg-img">
        <div className="container">
          <div
            id="conhecer"
            className="row margin session-one mb-5 bg-green py-3 py-md-0 p-md-0 text-white"
          >
            <div className="col-md-12">
              <div className="d-flex align-items-center">
                <img className="icon" src={IconSession} alt="icon-session" />
                <h2 className="text-white font-weight-bold mb-0">
                  É fácil, rápido e intuitivo, veja como funciona:
                </h2>
              </div>
              <div className="row mt-5 align-items-center">
                <div className="col-md-6 text">
                  <p className="font-weight-bold mb-2">Primeiro passo:</p>
                  <p className="mb-3 mb-md-0">
                    ⁠Escolha a petição que deseja elaborar, a legislação aplicável e informe o tema
                    ou documento, acompanhado de uma palavra-chave, para localizar as teses.
                  </p>
                </div>
                <div className="col-md-6">
                  <img src={Passo1} alt="Listar peças" width="100%" />
                </div>
              </div>
              <div className="row mt-5 align-items-center">
                <div className="col-md-6 order-2 order-md-1">
                  <img src={Passo2} alt="Petições" width="100%" />
                </div>
                <div className="col-md-6 text order-1 order-md-2">
                  <p className="font-weight-bold mb-2">Segundo passo:</p>
                  <p className="mb-0">
                    Em seguida, defina as teses que melhor se encaixam ao seu caso.{' '}
                    <strong className="text-white">
                      E, pronto! A sua petição está pronta para ser baixada!
                    </strong>
                  </p>
                  <button
                    type="button"
                    className="btn btn-warning font-weight-bold mt-4 mb-3 mb-md-0"
                    onClick={() => setSale(true)}
                  >
                    ASSINE E COMECE AGORA!
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row mt-4 align-items-center">
          <div className="col-md-3 d-flex justify-content-center mb-3 mb-md-0">
            <img src={Card} alt="Dr licita" className="img-fluid" />
          </div>
          <div className="col-md-9 text-img">
            <p className="d-flex align-items-center">
              <i className="material-icons mr-2 text-success">task_alt</i>
              Uso ilimitado: Crie quantas petições quiser
            </p>
            <p className="d-flex align-items-center">
              <i className="material-icons mr-2 text-success">task_alt</i>
              Teses atualizadas e alinhadas aos entendimentos dos Tribunais de Contas
            </p>
            <p className="d-flex align-items-center">
              <i className="material-icons mr-2 text-success">task_alt</i>
              Totalmente integrado à Plataforma ConLicitação
            </p>
            <p className="d-flex align-items-center">
              <i className="material-icons mr-2 text-success">task_alt</i>
              Testado e aprovado por Advogado especialistas em licitações públicas
            </p>
          </div>
        </div>
      </div>
      <div className="container mt-5 text-center">
        <div className="row">
          <div className="col-md-12 mt-5">
            <h3 className="font-weight-bold">
              Veja porque o <strong>Dr. Licita é a melhor IA</strong>
              <br /> para petições de licitações públicas:
            </h3>
            <div>
              <img src={Table} alt="Dr licita" className=" my-3" />
            </div>
            <button
              type="button"
              className="btn btn-sucess font-weight-bold mt-4 button-green text-white"
              onClick={() => setSale(true)}
            >
              ASSINAR O DR. LICITA
            </button>
          </div>
        </div>
        <div className="row my-5 text-center">
          <div className="col-md-12">
            <h3 className="font-weight-bold d-inline-flex align-items-center my-3">
              Dr. Licita e você com <i className="material-icons mr-2 text-success">add_2</i>
            </h3>
            <div className="row text-dark">
              <div className="col-sm-4 mb-3 mb-md-0">
                <div className="card text-left h-100 w-100">
                  <div className="card-body">
                    <img src={Clock} alt="Clock" className="img-fluid my-3" />
                    <div>
                      <h5 className="card-title font-weight-bold d-flex align-items-center">
                        <i className="material-icons text-success">add</i> Tempo
                      </h5>
                    </div>
                    <p className="card-text">
                      Chega de correr contra o relógio para protocolar suas petições no último dia.
                    </p>
                    <p className="mt-3">
                      Esqueça os dias que você ficou após o expediente em frente ao computador
                      porque não deu tempo de preparar a sua petição antes, entre leituras de
                      editais e outras tarefas urgentes.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-4 mb-3 mb-md-0">
                <div className="card text-left h-100 w-100">
                  <div className="card-body">
                    <img src={Justice} alt="Justice" className="img-fluid my-3" />
                    <div>
                      <h5 className="card-title font-weight-bold d-flex align-items-center">
                        <i className="material-icons text-success">add</i> Segurança Jurídica
                      </h5>
                    </div>
                    <p className="card-text">
                      Testado e aprovado pelo time Jurídico do ConLicitação, composto por advogados
                      especializados em licitações públicas, para te oferecer mais segurança
                      jurídica nas suas petições.
                    </p>
                    <p className="mt-3 font-weight-bold">
                      Livre-se de penalidades e preserve seus contratos!
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-4 mb-3 mb-md-0">
                <div className="card text-left h-100 w-100">
                  <div className="card-body">
                    <img src={Money} alt="money" className="img-fluid my-3" />
                    <div>
                      <h5 className="card-title font-weight-bold d-flex align-items-center">
                        <i className="material-icons text-success">add</i> Economia
                      </h5>
                    </div>
                    <p className="card-text">
                      Acesso às melhores teses para dominar suas licitações – pagando uma pequena
                      mensalidade que nem se compara aos honorários de um advogado!
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="row align-items-center p-4 rounded text-white"
          style={{ backgroundColor: '#0D875E' }}
        >
          <div className="col-md-12">
            <h3>Mais uma solução da empresa líder no mercado de licitações</h3>
            <button
              type="button"
              className="btn btn-dark font-weight-bold mt-4 bg-dark text-white p-2"
              onClick={() => setSale(true)}
            >
              ASSINAR O DR. LICITA
            </button>
          </div>
        </div>
        <div className="row text-left">
          <div className="col-md-12 my-5">
            <h2 className="text-dark text-center font-weight-bold my-5">Quem usou, recomenda!</h2>
            <div className="card-deck">
              <div className="card p-4 w-100">
                <img className="icon ml-2" src={IconComment} alt="icon-session" width={40} />
                <p className="mt-3">
                  "Estávamos participando de uma licitação quando tentaram nos inabilitar por causa
                  dos nossos atestados de capacidade técnica. Foi então que nos indicaram o Dr.
                  Licita, a ferramenta que nos ajudou a elaborar o recurso com agilidade. Tínhamos
                  apenas 5 dias úteis, e - com o Dr. Licita - elaboramos em um dia e protocolamos no
                  outro. Deu tudo certo e seguimos no certame!
                </p>
                <p>O Dr. Licita foi rápido e eficaz. A ferramenta é excelente. Super recomendo!"</p>
                <hr />
                <p className="font-weight-bold text-right mb-0">Thiago</p>
              </div>
              <div className="card p-4 w-100">
                <img className="icon ml-2" src={IconComment} alt="icon-session" width={40} />
                <p className="mt-3">
                  "Trabalhamos com monitoramento de veículos e em um Edital exigia-se registro no
                  CREA — algo totalmente descabido para a nossa atividade. Na prática, essa
                  exigência nos excluía injustamente do processo. Submetemos o Edital à análise do
                  Dr. Licita, que foir na dor! Foi em cima! Nos deu a tese correta: "Exigência de
                  registro no CREA"
                </p>
                <hr />
                <p className="font-weight-bold text-right mb-0">Bergson</p>
              </div>
              <div className="card p-4 w-100">
                <img className="icon ml-2" src={IconComment} alt="icon-session" width={40} />
                <p className="mt-3">
                  "Já fiz uma petição aqui. Que coisa maravilhosa! Que adianto em nossas vidas! Meu
                  Deus"
                </p>
                <hr />
                <p className="font-weight-bold text-right mb-0">Caio</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-dark" />
    </Container>
  );
};

export default PageSaleDrLicita;
